<template>
    <section>
        <div class="lesson_item" v-for="(itemLesson, indexLesson) in lessonArray" :key="indexLesson">
            <div class="lesson_item_main" @click="lessonItemClick(getCount(isFreeTrial), itemLesson.pk)">
                <div class="lesson_item_left">
                    <img :src="$qiNiuDomainBase + itemLesson.picture"/>
                </div>
                <div class="lesson_item_center">
                    <div class="lesson_content">
                        <div class="name">{{itemLesson.name}}</div>
                        <div class="fictionString">{{itemLesson.fictionString}}</div>
                        <div class="description" v-html="itemLesson.description"></div>
                    </div>
                </div>
                <img class="img_down" src="@/assets/growth_right.png" height="12.5" width="8"/>
                <img class="img2" v-if="getCount(itemLesson.finish) === 1" src="@/assets/240_course_finished.png" height="48"
                     width="60"/>
                <div class="clear"></div>
                <div v-if="getCount(isFreeTrial) === 1" class="free_trial">可试听</div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            lessonArray: {
                type: Array,
                default:() => []
            },
            selectedLessonPk:{
                type: String,
                default: '0'
            },
            isFreeTrial:{
                type: String,
                default: '0'
            }
        },
        methods: {
            lessonItemClick(isFreeTrial, lesson) {
                this.$emit('lessonItemClick', isFreeTrial, lesson);
            }
        }
    }
</script>

<style scoped>
    img { pointer-events: none; }

    .lesson_item .lesson_item_main {
        position: relative;
        background-color: white;
        margin-left: 10px;
        margin-right: 10px;
        margin-Top: 20px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(255, 255, 255, 100);
    }
    .lesson_item .lesson_item_main .lesson_item_left {
        float: left;
        width: 100px;
        margin: 10px;
    }
    .lesson_item .lesson_item_main .lesson_item_left img {
        width: 100%;
        height:100%;
    }
    .lesson_item .lesson_item_main .lesson_item_center {
        float: left;
        margin-left: 5px;
        width: calc(100% - 105px - 30px);
        display: flex;
        align-items: center;
    }
    .lesson_item .lesson_item_main .lesson_content {
        width: 100%;
    }
    .lesson_item .lesson_item_main .lesson_item_center .name {
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .lesson_item .lesson_item_main .lesson_item_center .fictionString {
        font-size: 14px;
        margin-top: 0;
    }
    .lesson_item .lesson_item_main .lesson_item_center .description {
        font-size: 15px;
        color: #666666;
        margin-top: 3px;
        margin-bottom: 10px;
        margin-right:15px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .lesson_item .lesson_item_main .img_down {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        right: 12px;
    }
    .lesson_item .lesson_item_main .img2 {
        position: absolute;
        top: 5px;
        right: 10px;
        -webkit-transform: translateY(5px);
    }
    .lesson_item .lesson_item_sun {
        background-color: white;
        margin-left: 15px;
        margin-right: 15px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        border: 1px solid rgba(255, 255, 255, 100);
    }
    .lesson_item .lesson_item_sun .course_audio {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 16px;
        padding-bottom:16px;
    }
    .lesson_item .lesson_item_sun .course_audio_c {
        border: 1px solid #e3e2e2;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 12px 8px 12px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .lesson_item .lesson_item_sun .course_audio .course_audio_img {
        display: inline-block;
    }
    .lesson_item .lesson_item_sun .course_audio .course_audio_img img {
        width: 25px;
        height: 25px;
        margin-right: 10px;
        vertical-align: middle;
    }
    .lesson_item .lesson_item_sun .course_audio .course_audio_info {
        display: inline-block;
    }
    .lesson_item .lesson_item_sun .course_audio .course_audio_info .title {
        font-size: 15px;
        color: #333;
        line-height: 15px;
    }
    .lesson_item .lesson_item_sun .course_audio .course_audio_info .time {
        font-size: 12px;
        line-height: 12px;
        margin-top: 5px;
        color: #999;
    }
    .lesson_item .lesson_item_sun .course_action {

    }
    .lesson_item .lesson_item_sun .course_action .action {
        float: left;
        width: 50%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
    }
    .lesson_item .lesson_item_sun .course_action .action .action_num {
        color: #ff505a;
        font-size: 34px;
        font-weight: bold;
        margin-right:5px;
    }
    .lesson_item .lesson_item_sun .course_action .action img {
        width: 60px;
        height: 60px;
    }
    .lesson_item .lesson_item_sun .course_action .action .title {
        font-size: 14px;
    }
    .free_trial {
        position: absolute;
        top: 0;
        right:0;
        background-color: #ff5a50;
        font-size: 13px;
        font-weight: bold;
        color: white;
        padding: 2px 5px 2px 5px;
        border-top-right-radius:5px;
        -webkit-border-top-right-radius: 5px;
        -moz-border-radius-topright: 5px;
    }
</style>
